import { useState } from 'react'

/** Tiny input for individual spacing sides (T/R/B/L) — blur-to-commit */
export function SpacingMiniField({
  label,
  value,
  onChange,
}: {
  label: string
  value: string
  onChange: (value: string) => void
}) {
  const [draft, setDraft] = useState(value)
  const [focused, setFocused] = useState(false)

  if (!focused && draft !== value) {
    setDraft(value)
  }

  return (
    <div className="flex flex-col items-center gap-0.5">
      <span className="text-[9px] text-muted-foreground">{label}</span>
      <input
        type="text"
        data-testid={`spacing-${label.toLowerCase().replace(/\s+/g, '-')}`}
        className="w-full h-6 text-center text-xs border border-input rounded bg-background focus:outline-none focus:ring-1 focus:ring-ring"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => {
          setFocused(false)
          if (draft !== value) onChange(draft)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
              ; (e.target as HTMLElement).blur()
          }
          if (e.key === 'Escape') {
            setDraft(value)
              ; (e.target as HTMLElement).blur()
          }
        }}
        placeholder="-"
      />
    </div>
  )
}
